module.exports = __webpack_public_path__ + "static/media/sitebuilder_success_br.cd4e0fb8.png";